module.exports = __webpack_public_path__ + "ir.svg?86a03e70b7f42d89a3002e458ff36876";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ir.svg
// module id = 1034
// module chunks = 27